export const SET_USER = 'SET_USER';
export const SET_LOCALE = 'SET_LOCALE';
